import { Tooltip } from '@/ui/tooltip';

import { StatusIcon } from './status-icon';

type Props = {
  onPress: () => void;
  size?: number;
};

export const ClickableStatusIcon = ({ onPress, size = 16 }: Props) => {
  return (
    <Tooltip text="Click to see attached documents" onPress={onPress}>
      <StatusIcon status="verified" size={size} />
    </Tooltip>
  );
};
